import { BookOpen, LayoutDashboard, Mail } from 'lucide-react';
import { LandingHeader } from '@/components/LandingHeader';
import { LandingFooter } from '@/components/LandingFooter';
import { useTranslation } from '@/hooks/useTranslation';
import { SpotlightCard, Stagger, StaggerItem } from '@/components/landing/motion-primitives';
import { CtaSection, PageHero, Section } from '@/components/landing/page-kit';

export default function HelpCenterPage() {
  const { t, language } = useTranslation();
  const fr = language !== 'en';

  const topics = [
    { icon: BookOpen, text: t('help.tutorial' as any) },
    { icon: LayoutDashboard, text: t('help.dashboard' as any) },
    { icon: Mail, text: t('help.contact' as any) },
  ];

  return (
    <div className="min-h-screen bg-background text-foreground">
      <LandingHeader />

      <main>
        <PageHero
          eyebrow={fr ? 'Support' : 'Support'}
          title={t('help.title' as any)}
          subtitle={
            fr
              ? 'Les réponses aux questions les plus fréquentes, et une équipe joignable directement.'
              : 'Answers to the most common questions, and a team you can reach directly.'
          }
        />

        {/* ── Pistes d'aide ──────────────────────────────────────── */}
        <Section className="pt-0 lg:pt-0">
          <Stagger className="grid gap-4 md:grid-cols-3" stagger={0.08}>
            {topics.map((topic, i) => (
              <StaggerItem key={i}>
                <SpotlightCard className="h-full rounded-xl border border-border bg-card p-7 transition-shadow duration-300 hover:shadow-lg">
                  <topic.icon className="h-5 w-5 text-primary" />
                  <p className="mt-5 text-pretty text-sm leading-relaxed text-muted-foreground">
                    {topic.text}
                  </p>
                </SpotlightCard>
              </StaggerItem>
            ))}
          </Stagger>

          <Stagger className="mt-16 text-center" stagger={0.08}>
            <StaggerItem>
              <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-muted-foreground">
                {fr ? 'Une question précise ?' : 'A specific question?'}
              </p>
            </StaggerItem>
            <StaggerItem>
              <a
                href="mailto:founders@cleviaapp.com"
                className="mt-4 inline-flex text-lg font-medium text-brand-700 transition-opacity hover:opacity-80 dark:text-brand-400"
              >
                founders@cleviaapp.com
              </a>
            </StaggerItem>
          </Stagger>
        </Section>

        {/* ── CTA final ──────────────────────────────────────────── */}
        <CtaSection
          title={fr ? 'On vous répond directement' : 'We answer you directly'}
          subtitle={
            fr
              ? 'Écrivez-nous : ce sont les fondateurs qui lisent et répondent aux messages.'
              : 'Write to us: the founders read and answer the messages themselves.'
          }
          action={{ label: t('help.contactButton' as any), href: 'mailto:founders@cleviaapp.com' }}
        />
      </main>

      <LandingFooter />
    </div>
  );
}
